(function() {
    class HeroVideo extends HTMLElement {
      constructor() {
        super();
        this.video = this.querySelector('.ai-hero-video__video-adev');
      }

      connectedCallback() {
        if (this.video) {
          this.setupLazyLoad();
          this.handleAutoplay();
        }
      }

      setupLazyLoad() {
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.loadVideo();
                observer.unobserve(this);
              }
            });
          }, {
            rootMargin: '50px'
          });

          observer.observe(this);
        } else {
          this.loadVideo();
        }
      }

      loadVideo() {
        if (this.video && this.video.readyState === 0) {
          this.video.load();
        }
      }

      handleAutoplay() {
        if (this.video && this.video.hasAttribute('autoplay')) {
          const playPromise = this.video.play();
          
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              this.video.muted = true;
              this.video.play();
            });
          }
        }
      }
    }

    customElements.define('hero-video-adev', HeroVideo);
  })();